function parseOpacity ({ opacity = 0 }) {
  return {
    opacity: opacity.value + opacity.unit
  }
}

export default parseOpacity
